<template>
  <div class="send-sms">

    <v-text-field
      :label="$t('insertMobileNo')"
      v-model="user_mobile"
      outlined
    ></v-text-field>

    <v-btn class="save-edit-btn" v-on:click="send_sms()">{{ $t('sendCode') }}</v-btn>
  </div>

</template>
<script>
  export default {
    data () {
      return {
        user_mobile :'',
        user_name :'',
        user_code :'',

        error: []
      }
    },
    mounted () {
      this.profile()
    },
    methods: {
      profile () {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        this.user_name = user_data.UserName
        this.user_code = user_data.UserCode
        this.user_id = user_data.UserId
        console.log(JSON.parse(localStorage.getItem('profile')))
        this.user_mobile = localStorage.getItem('phone')
      },
      send_sms () {
        var self = this
        if (this.user_mobile == '' || this.user_mobile == ' ') {
          this.error.push(this.$t('mobileIsEmpty'))
        }
        if (this.user_mobile != '') {
          const send_data = {
            MobileNo:this.user_mobile,
          }
          this.axios.post('/GetNewSms', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                self.$router.push({ name:self.$t('changePassword'), params:{} })
              }
            }).catch(e => {

            })
        }
      }
    }

  }
</script>
